export default "__VITE_ASSET__Be4Uo4mP__"